import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';

export const BoxLinkGallery = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 1em;

  ${breakpointsMedia({
    md: css`
      grid-template-columns: repeat(2, 1fr);
    `,
    lg: css`
      grid-template-columns: repeat(3, 1fr);
    `,
  })}
`;

export const BoxLink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;
  box-sizing: border-box;
  padding: ${spacing('8x')};
  background: ${nuDSColor('white')};
  margin-bottom: ${spacing('8x')};
  height: 204px;

  ${breakpointsMedia({
    md: css`
      height: 304px;
      max-width: 100%
    `,
  })}
`;
